import React from 'react';
import PropTypes from 'prop-types';
import cn from 'utils/classnames';
import styles from './ToogleButton.module.scss';

const ToogleButton = React.forwardRef((props, ref) => {
  const { id, checked, onChange, disabled, className, ...rest } = props;

  return (
    <input
      ref={ref}
      id={id}
      type="checkbox"
      role="switch"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={cn(styles.Switch, className)}
      {...rest}
    />
  );
});

ToogleButton.displayName = 'ToogleButton';

ToogleButton.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

ToogleButton.defaultProps = {
  checked: false,
  onChange: () => {},
  disabled: false,
  className: '',
};

export default React.memo(ToogleButton);
